import { createContext, useContext } from 'react'

const ModalMode = createContext(false)

export function ModalModeProvider({ children }: { children: React.ReactNode }) {
  return <ModalMode.Provider value={true}>{children}</ModalMode.Provider>
}

export function useModalMode() {
  return useContext(ModalMode)
}
